<template>
  <div class="w-full flex flex-col items-center p-2">
    <div v-if="loading" class="flex flex-col items-center py-8">
      <a-spin size="large" />
      <p class="text-slate-500 dark:text-slate-400 mt-5 text-sm">正在跳转微信授权...</p>
    </div>
    <div v-else class="w-full flex flex-col items-center pt-4">
      <img
        :src="avatarSrc"
        alt=""
        class="w-[88px] h-[88px] rounded-full object-cover mb-6 shadow-md ring-[3px] ring-white dark:ring-slate-800"
      />
      <a-button type="primary" size="large" block class="!w-[200px] mb-4" @click="$emit('authorize')">
        授权登录
      </a-button>
      <div class="text-xs text-slate-400 dark:text-slate-500">
        点击后将跳转至微信授权页面
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OAuthLoginPanel',
  props: {
    loading: { type: Boolean, default: false },
    avatarSrc: { type: String, required: true }
  },
  emits: ['authorize']
}
</script>
